// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3K47U","errorLogs":"styles_errorLogs__2ADFf"};